import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import successicon from "assets/images/successlogout.svg";
import { Button } from "components/ui/Button";
import { pathGenerators } from "utils/routes";

import { Common } from "../components/Common/Common";
import s from "./LogoutPage.module.css";

const LogoutPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(pathGenerators.auth.login());
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((c) => (c <= 0 ? 0 : c - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={s.page}>
      <Common />
      <div className={s.card}>
        <div className={s.iconWrapper}>
          <img src={successicon} alt="" />
          <div className={s.checkmark}>
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20,6 9,17 4,12" />
            </svg>
          </div>
        </div>

        <div className={s.content}>
          <h3 className={s.title}>Successfully Logged Out</h3>
          <h5 className={s.subtitle}>
            Thank you for using Kinesin Health. Have a great day!
          </h5>
          <div className={s.countdown}>
            <p>
              You will be redirected to login in <span>{countdown}</span> seconds
            </p>
          </div>
        </div>

        <div className={s.btnContainer}>
          <Button
            size="large"
            onClick={() => navigate(pathGenerators.auth.login())}
          >
            Back to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export { LogoutPage };
